import "./appConfig/config.ts";
import "./global.scss";

import { CSSReset, ChakraProvider } from '@chakra-ui/react';

import { Provider } from "react-redux";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { router } from './appConfig/AppRouter';
import store from './store/store';
import theme from "./theme/theme";

const bc = new BroadcastChannel("auth");

bc.onmessage = (event) => {
  if (event.data === "logout") {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userRole");
    sessionStorage.clear();
    window.location.href = "/login"; // instant cross-tab logout
  }
};


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
        <Provider store={store}>
            <ChakraProvider theme={theme}>
                <CSSReset/>
                    <RouterProvider router={router} />
            </ChakraProvider>
        </Provider>
    </React.StrictMode>
);


reportWebVitals();
